import { optional, string, ZodLessInfer } from '@kaiizen/zod-less';
import { ApiOrgContractorBaseSchema } from './ApiOrgContractorBaseSchema';
import { ApiOrgMarketSchema } from './ApiOrgMarketSchema';

export const ApiOrgContractorSchema = ApiOrgContractorBaseSchema.extend({
  contractorMarkets: optional(
    [{ orgMarket: ApiOrgMarketSchema }],
  ),
});
export const ApiCreateOrgContractorSchema = ApiOrgContractorSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  archivedAt: true,
  orgId: true,
  contractorMarkets: true,
});
export const ApiUpdateOrgContractorSchema = ApiOrgContractorSchema.omit({ id: true, createdAt: true, updatedAt: true, orgId: true, contractorMarkets: true })
  .extend({
    archivedAt: string.nullable().optional(),
    // Nullable so an update can clear a contact field (null = clear; omitted = leave alone).
    email: string.nullable().optional(),
    phoneNumber: string.nullable().optional(),
  }).partial();
export type ApiOrgContractor = ZodLessInfer<typeof ApiOrgContractorSchema>;
export type ApiCreateOrgContractor = ZodLessInfer<typeof ApiCreateOrgContractorSchema>;
export type ApiUpdateOrgContractor = ZodLessInfer<typeof ApiUpdateOrgContractorSchema>;

export type ApiOrgContractorsMap = Record<string, ApiOrgContractor>;
export const getOrgContractorsQueryKeyPrefix = () => `orgContractors`;
export const getOrgContractorQueryKey = (id?: string | null) => `orgContractor/${id}`;
export const getOrgContractorsQueryKey = (archived?: boolean, search?: string) =>
  `${getOrgContractorsQueryKeyPrefix()}/${archived ? 'archived' : 'active'}/${search?.trim() || 'all'}`;
export const getOrgContractorsByOrgMarketIdQueryKey = (orgMarketId?: string | null) => `${getOrgContractorsQueryKeyPrefix()}/by-org-market-id/${orgMarketId}`;
